import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { ClapSpinner } from "react-spinners-kit";
import { onlinePaymentConfirm } from "@ticketsaction";
import { STRIPE_PUBLISHABLE_KEY, STRIPE_PUBLISHABLE_KEY_UK } from "@constant";
import LocaleStrings from "@language";

const Callback = (props) => {
  const stripe = useStripe();
  const navigate = useNavigate();
  const location = useLocation();
  const { session, eventSettingsData } = props;
  const [loading, setLoading] = useState(true);
  const [errormessage, setErrorMessage] = useState(null);

  const params = new URLSearchParams(location.search);
  // console.log("params :- ", params.toString());
  const lang = params.get("lang");
  const headoff = params.get("header_footer");

  const newParams = new URLSearchParams();
  if (lang) newParams.set("lang", lang);
  if (headoff) newParams.set("header_footer", headoff);
  const param = newParams.size > 0 ? `?${newParams.toString()}` : "";

  useEffect(() => {
    // console.log("stripe callback here.....");
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(location.search).get(
      "payment_intent_client_secret"
    );
    // console.log("clientSecret :- ", clientSecret);
    const transactionId = new URLSearchParams(location.search).get(
      "payment_intent"
    );
    // console.log("transactionId :- ", transactionId);

    if (!clientSecret) {
      return;
    }

    let paymentgateway = location.pathname.includes("eventify_callback")
      ? "eventify"
      : "stripe";

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      // console.log("paymentIntent :- ", paymentIntent);

      switch (paymentIntent?.status) {
        case "succeeded":
          let link = "";
          if (eventSettingsData?.data?.thankyoulink) {
            let linkVal = eventSettingsData?.data?.thankyoulink;
            if (linkVal.search("http") === -1) {
              link = `http://${linkVal}`;
            } else {
              link = linkVal;
            }
          }

          props.onlinePaymentConfirm(
            session,
            { payment_intent: transactionId, gateway: paymentgateway },
            (response) => {
              // console.log("api response :- ", response);
              setLoading(false);

              if (response?.success === 1) {
                eventSettingsData?.data?.thankyoulink
                  ? (window.location.href = link)
                  : navigate(
                      `/tickets/ticketorder/${response?.data?.resource?.ordernumber}${param}`,
                      {
                        state: { ...(response?.data?.resource ?? {}) },
                      }
                    );
              } else if (response?.success === 2) {
                if (response?.data?.code === "transactionid_required") {
                  setErrorMessage(LocaleStrings.kTransactionidRequiredText);
                } else if (response?.data?.code === "invalid_transactionid") {
                  setErrorMessage(LocaleStrings.kInvalidTransactionidText);
                } else if (
                  response?.data?.code === "stripe_account_not_connected"
                ) {
                  setErrorMessage(LocaleStrings.kStripeNotConnectedText);
                } else if (response?.data?.code === "order_already_confirmed") {
                  setErrorMessage(LocaleStrings.kOrderAlreadyConfirmedText);
                } else {
                  setErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
                }
              } else {
                setErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
              }
            }
          );
          break;
        case "processing":
          setLoading(false);
          setErrorMessage(LocaleStrings.kStripeProcessing);
          break;
        case "requires_payment_method":
          setLoading(false);
          setErrorMessage(LocaleStrings.kStripePaymentFailedText);
          break;
        default:
          setLoading(false);
          setErrorMessage(LocaleStrings.kStripePaymentFailedText);
          break;
      }
    });
  }, [stripe]);

  const goToTickets = () => {
    navigate(`/tickets${param}`, { replace: true });
  };

  return (
    <div className="content-body ticket-related-container">
      {!loading ? (
        <div className="stripe-callback-container">
          {/* Show any error or success messages */}
          {errormessage && (
            <div className="payment-confirm-error-message">{errormessage}</div>
          )}

          <div
            className="custom-text-theme-md-medium cursor-pointer underline"
            onClick={goToTickets}
          >
            {LocaleStrings.kGoToHomeText}
          </div>
        </div>
      ) : (
        <div className="content-body pt-14 custom-item-center flex-col space-y-8 bg-white h-full">
          <div className="max-w-max mx-auto">
            <main className="sm:flex">
              <div className="sm:ml-6">
                <div className="sm:border-l sm:border-ternary sm:pl-6 transition ease-in-out duration-700">
                  <ClapSpinner
                    size={40}
                    frontColor="var(--theme_color)"
                    backColor="var(--theme_color)"
                  />
                </div>
              </div>
            </main>
          </div>
          <div className="custom-text-primary-lg-bold">
            {LocaleStrings.kStripeLoading}
          </div>
        </div>
      )}
    </div>
  );
};

const StripeCallback = (props) => {
  const { stipeaccountid } = useParams();
  const { eventData } = props;
  let billingAccountInfo = eventData?.platform_billing_account
    ? JSON.parse(eventData.platform_billing_account)
    : { stripe: "AU" };
  let stripeBillingAccount = billingAccountInfo?.stripe ?? "AU";
  let PK =
    stripeBillingAccount === "UK"
      ? STRIPE_PUBLISHABLE_KEY_UK
      : STRIPE_PUBLISHABLE_KEY;

  const stripePromise = loadStripe(PK, {
    stripeAccount: stipeaccountid,
  });

  return (
    <Elements stripe={stripePromise}>
      <Callback {...props} />
    </Elements>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
  eventData: state.eventData,
  eventSettingsData: state.eventSettingsData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ onlinePaymentConfirm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StripeCallback);
